import React, { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { translateErrorMessage } from '../../../dynamicErrorTranslator'; // Your translator
 
const ToastContext = createContext();
 
export const ToastProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [toastObj, setToastObj] = useState({
    open: false,
    type: null,
    message: null,
    originalMessage: null, // Store original message for retranslation
  });
 
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate());
  const formattedCurrentDate = currentDate.toISOString().split("T")[0];
 
  // Get yesterday's date
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const formattedYesterday = yesterday.toISOString().split("T")[0];
 
  // Enhanced handleToastOpen with translation
  const handleToastOpen = async (type, message) => {
    // Translate the message to current language
    const translatedMessage = await translateErrorMessage(message);
    
    setToastObj({
      open: true,
      type: type,
      message: translatedMessage, // Use translated message
      originalMessage: message,   // Keep original for retranslation
      isMaintenance:
        type === "error" &&
        message ===
          "Data refresh ongoing, old data might be inaccessible during this duration. Please do not make any changes during this time",
      isOutdated:
        type === "error" &&
        (message ===
          `The data was refereshed last on ${formattedCurrentDate}` ||
          message === `The data was refereshed last on ${formattedYesterday}`),
    });
  };
 
  const handleToastClose = () => {
    setToastObj({ open: false });
  };
 
  // Re-translate message when language changes
  useEffect(() => {
    const retranslateMessage = async () => {
      if (toastObj.open && toastObj.originalMessage) {
        const newTranslatedMessage = await translateErrorMessage(toastObj.originalMessage);
        
        setToastObj(prev => ({
          ...prev,
          message: newTranslatedMessage
        }));
      }
    };
 
    retranslateMessage();
  }, [i18n.language]); // Retranslate when language changes
 
  return (
    <ToastContext.Provider
      value={{
        toastObj,
        handleToastOpen,
        handleToastClose,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};
 
export const useToast = () => {
  return useContext(ToastContext);
};